//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 } from 'uuid';

export default {
    props: {
        sinceDate: {
            type: String
        },
        toDate: {
            type: String
        }
    },
    data: function data() {
        return {
            id: v4(),
            openDialog: false,
            dateOne: null,
            dateTwo: null
        };
    },

    watch: {
        openDialog: function openDialog(val) {
            if (val) {
                this.dateOne = this.sinceDate;
                this.dateTwo = this.toDate;
            }
        }
    },
    computed: {
        maxDate: function maxDate() {
            if (this.dateOne) {
                this.$moment(this.dateOne, 'YYYY-MM-DD').clone().add(1, 'month').toDate();
            }
            return null;
        }
    },
    methods: {
        open: function open() {
            this.openDialog = true;
        },
        apply: function apply() {
            if (this.$store.state.dashboard.filters.dateAdminOrHight === 'date admission') {
                this.$store.commit('dashboard/filters/setAdmisionStartDate', this.dateOne);
                this.$store.commit('dashboard/filters/admisionEndDate', this.dateTwo);
            } else {
                this.$store.commit('dashboard/filters/setHighStartDate', this.dateOne);
                this.$store.commit('dashboard/filters/setHighEndDate', this.dateTwo);
            }
            this.openDialog = false;
            this.$emit('selected', {
                sinceDate: this.dateOne,
                toDate: this.dateTwo
            });
            this.dateOne = this.dateTwo = null;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/date-option-range.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/date-option-range.vue
// module chunks = 0 5